import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";

export function Footer(): JSX.Element {
  return (
    <Box component="footer" sx={{
        backgroundColor: '#0b3a5d',
        padding: '20px 0',
        color: 'white',
    }}>
    <Container>
      <Box>
        <Typography className="footer-text" component="p">
          Alignment Health Plan is an HMO, HMO POS, HMO C-SNP, HMO D-SNP and PPO plan with a Medicare contract and a contract with the California, Nevada, North Carolina and Texas Medicaid programs. Enrollment in Alignment Health Plan depends on contract renewal.
        </Typography>
      </Box>
      <Box className="metadata-container">
        <div>
          <Typography>
            ©Copyright {new Date().getFullYear()} Alignment Health Plan. All
            Rights Reserved
          </Typography>
        </div>
        <div>
          <Typography>Page last updated on October 1, 2026 | Y0141_27337EN_M</Typography>
        </div>
      </Box>
    </Container>
    </Box>
  );
}

export default Footer;